export default __webpack_public_path__ + "static/media/how-it-works_02.2f5222cb.png";